<template>
  <div>
    <div v-if="loading">
      <skeleton-revenue />
    </div>
    <div v-else>
      <div class="vuse-content-wrapper mt-4 mx-6">
        <v-row>
          <v-col cols="12" lg="2" class="mt-0">
            <h2 class="ml-3 float-left">
              {{$t(page+'.title')}}
            </h2>
          </v-col>
          <v-spacer />
          <v-col class="text-right" cols="12" lg="10">
            <h2 class="mr-3 float-right">
              {{$t(page+'.Subscribe the fittest solution for your needs')}}
            </h2>
          </v-col>
        </v-row>
        <template v-if="!services && !loading">
          <no-data />
        </template>
        <template v-else>
          <v-row>
            <v-col cols="12" md="4">
              <v-card class="pb-2 neu-glow">
                <h2 class="mb-3">
                  <v-card
                    color="primary"
                    class="px-4 py-1 mb-2"
                    style="height: 200px"
                  >
                    <div class="text-h7 black--text">
                      {{$t(page+'.Shown Prices and Options are based on your current settings')}}.
                    <div class="text-h7 black--text" v-if="settings.plan_id&&settings.next_billing_time">
                      {{$t(page+'.and subscribed the')}} <v-div class="text-center white--text" >"{{settings.plan_name}}" </v-div> {{$t(page+'.Plan')}}
                      <div class="text-h7 black--text">
                        {{$t(page+'.Next Payment on')}} <v-div class="text-center white--text" >{{formattedNextBillingDate}}</v-div>
                      </div>
                      <div> {{$t(page+'.or')}} 
                        <v-btn
                          color="red darken-2"
                          @click="dialog_cancel_subscription=1"
                          class="ml-8 my-5"
                          rounded
                          >{{
                            $t(page+'.Cancel Subscription')
                          }}
                          </v-btn>
                      </div>
                    </div>
                    <div class="text-h7 black--text" v-if="settings.subscribedeBayAccountsCount<settings.eBayAccountsCount&&settings.eBayAccountsCount>1">
                      <div v-if="settings.subscribedeBayAccountsCount==0">
                        {{$t(page+'.but you have not subscribed for a plan yet, therefore you need to upgrade your subscription')}}.
                      </div>
                      <div v-else class="text-h7 black--text">
                        {{$t(page+'.but you have subscribed for just')}} {{settings.subscribedeBayAccountsCount}} {{$t(page+'.eBay Accounts, therefore you need to upgrade your subscription')}}.
                      </div>
                    </div>
                    <div class="text-h7 black--text" v-else-if="settings.subscribedeBayAccountsCount>settings.eBayAccountsCount">
                      {{$t(page+'.but you have binded')}} {{settings.eBayAccountsCount}} {{$t(page+'.eBay Accounts, therefore, if you do not foresee to add eBay account soon, you can downgrade your subscription')}}.
                    </div>
                  </v-card>
                </h2>
                <template v-for="s in services">
                  <v-div v-if="s.name" :key="s" class="my-3 ml-5">
                    {{ s.name }}
                  </v-div>
                  <v-divider :key="s" class="my-3 mx-6"></v-divider>
                </template>
              </v-card>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-hover v-slot="{ hover }">
                <v-card class="pb-2 neu-glow" :elevation="hover ? 12 : 2">
                  <h2 class="mb-3">
                    <v-card
                      color="#333"
                      dark
                      class="pa-4 rounded-b-0"
                      style="height: 130px"
                    >
                      <span class="text-h5">{{$t(page+'.Free')}}</span>
                      <div class="display-2 font-weight-black">
                        {{ String(prices_plan2[0]).split(".")[0] }}.<sup
                          >{{ String(prices_plan2[0]).split(".")[1] }}00</sup
                        >
                      </div>
                    </v-card>
                    <v-card
                      color="#999"
                      dark
                      class="pa-4 mb-2 rounded-t-0"
                      style="height: 70px"
                    >
                      <div class="text-h7">{{$t(page+'.1 eBay Account Only')}}</div>
                    </v-card>
                  </h2>
                  <template v-for="s in services">
                    <template v-if="s.level">
                      <v-icon v-if="s.level > 0&&s.name!='Refund Report'" color="green" :key="s"
                        >fa-check</v-icon
                      >
                      <v-icon v-else color="red" :key="s">fa-times</v-icon>
                    </template>
                    <div class="mt-2 text-h5 font-weight-black" v-else :key="s">
                      {{ String(prices_plan[0]) }}.<sup>00</sup>
                    </div>
                    <v-divider :key="s" class="my-35 mx-6"></v-divider>
                  </template>
                  <v-btn
                    :disabled="disabled_plan[0] == 1"
                    :color="selected_plan.planlevel == 0 ? 'blue' : 'primary'"
                    @click="selectPlan(0)"
                    class="my-5"
                    rounded
                    >{{ $t(select_plan_text[0]) }}</v-btn
                  >
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-hover v-slot="{ hover }">
                <v-card class="pb-2 neu-glow" :elevation="hover ? 12 : 2">
                  <h2 class="mb-3">
                    <v-card
                      color="#333"
                      dark
                      class="pa-4 rounded-b-0"
                      style="height: 130px"
                    >
                      <span class="text-h5">{{$t(page+'.Basic')}}</span>
                      <div class="display-2 font-weight-black">
                        ${{ String(prices_plan2[1]).split(".")[0] }}.<sup
                          >{{ String(prices_plan2[1]).split(".")[1] }}0</sup
                        ><sub class="text-h8 ml--40">{{$t(page+'.monthly')}}</sub>
                      </div>
                    </v-card>
                    <v-card
                      color="#999"
                      dark
                      class="pa-1 mb-2 rounded-t-0"
                      style="height: 70px"
                    >
                      <div class="text-h8">{{$t(page+'.2 eBay Accounts included')}}</div>
                      <div class="text-h8">
                        {{$t(page+'.Need to connect more accounts?')}}<br />{{$t(page+'.It\'s only $3.00 each')}}
                      </div>
                    </v-card>
                  </h2>
                  <template v-for="s in services">
                    <template v-if="s.level">
                      <v-icon v-if="s.level < 2" color="green" :key="s"
                        >fa-check</v-icon
                      >
                      <v-icon v-else color="red" :key="s">fa-times</v-icon>
                    </template>
                    <div
                      :class="`mt-2 text-h5 font-weight-black ${class_notEyal}`"
                      v-else-if="settings.eBayAccountsCount > 1"
                      :key="s"
                    >
                      ${{ String(prices_plan[1]).split(".")[0]
                      }}<sup>{{ String(prices_plan[1]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <div
                      :class="`mt-2 text-h5 font-weight-black ${class_isEyal}`"
                      v-else
                      :key="s"
                    >
                      ${{ String(prices_plan2[1]).split(".")[0]
                      }}<sup>{{ String(prices_plan2[1]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <v-divider :key="s" class="my-35 mx-6"></v-divider>
                  </template>
                  <v-btn
                    :disabled="disabled_plan[1] == 1"
                    :color="selected_plan.planlevel == 1 ? 'blue' : 'primary'"
                    @click="selectPlan(1)"
                    class="my-5"
                    rounded
                    >{{
                      $t(select_plan_text[1])
                    }}</v-btn
                  >
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-hover v-slot="{ hover }">
                <v-card class="pb-2 neu-glow" :elevation="hover ? 12 : 2">
                  <h2 class="mb-3">
                    <v-card
                      color="#333"
                      dark
                      class="pa-4 rounded-b-0"
                      style="height: 130px"
                    >
                      <span class="text-h5">{{$t(page+'.Pro')}}</span>
                      <div class="display-2 font-weight-black">
                        ${{ String(prices_plan2[2]).split(".")[0] }}.<sup
                          >{{ String(prices_plan2[2]).split(".")[1] }}0</sup
                        ><sub class="text-h8 ml--40">{{$t(page+'.monthly')}}</sub>
                      </div>
                    </v-card>
                    <v-card
                      color="#999"
                      dark
                      class="pa-1 mb-2 rounded-t-0"
                      style="height: 70px"
                    >
                      <div class="text-h8">{{$t(page+'.2 eBay Accounts included')}}</div>
                      <div class="text-h8">
                        {{$t(page+'.Need to connect more accounts')}}?<br />{{$t(page+'.It\'s only $3.00 each')}}
                      </div>
                    </v-card>
                  </h2>
                  <template v-for="s in services">
                    <template v-if="s.level">
                      <v-icon v-if="s.level < 4" color="green" :key="s"
                        >fa-check</v-icon
                      >
                      <v-icon v-else color="red" :key="s">fa-times</v-icon>
                    </template>
                    <div
                      :class="'mt-2 text-h5 font-weight-black '+ class_notEyal"
                      v-else-if="settings.eBayAccountsCount > 1"
                      :key="s"
                    >
                      ${{ String(prices_plan[2]).split(".")[0]
                      }}<sup>{{ String(prices_plan[2]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <div :class="'mt-2 text-h5 font-weight-black '+ class_isEyal"
                    v-else :key="s">
                      ${{ String(prices_plan2[2]).split(".")[0]
                      }}<sup>{{ String(prices_plan2[2]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <v-divider :key="s" class="my-35 mx-6"></v-divider>
                  </template>
                  <v-btn
                    :disabled="disabled_plan[2] == 1"
                    :color="selected_plan.planlevel == 3 ? 'blue' : 'primary'"
                    @click="selectPlan(3)"
                    class="my-5"
                    rounded
                    >{{
                      $t(select_plan_text[2])
                    }}</v-btn
                  >
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-hover v-slot="{ hover }">
                <v-card class="pb-2 neu-glow" :elevation="hover ? 12 : 2">
                  <h2 class="mb-3">
                    <v-card
                      color="#333"
                      dark
                      class="pa-4 rounded-b-0"
                      style="height: 130px"
                    >
                      <span class="text-h5">{{$t(page+'.Premium')}}</span>
                      <div class="display-2 font-weight-black">
                        ${{ String(prices_plan2[3]).split(".")[0] }}.<sup
                          >{{ String(prices_plan2[3]).split(".")[1] }}0</sup
                        ><sub class="text-h8 ml--40">{{$t(page+'.monthly')}}</sub>
                      </div>
                    </v-card>
                    <v-card
                      color="#999"
                      dark
                      class="pa-1 mb-2 rounded-t-0"
                      style="height: 70px"
                    >
                      <div class="text-h8">{{$t(page+'.2 eBay Accounts included')}}</div>
                      <div class="text-h8">
                        {{$t(page+'.Need to connect more accounts')}}?<br />{{$t(page+'.It\'s only $3.00 each')}}
                      </div>
                    </v-card>
                  </h2>
                  <template v-for="s in services">
                    <template v-if="s.level">
                      <v-icon v-if="s.level > 0" color="green" :key="s"
                        >fa-check</v-icon
                      >
                      <v-icon v-else color="red" :key="s">fa-times</v-icon>
                    </template>
                    <div
                      :class="`mt-2 text-h5 font-weight-black ${class_notEyal}`"
                      v-else-if="settings.eBayAccountsCount > 1"
                      :key="s"
                    >
                      ${{ String(prices_plan[3] + s.price[3]).split(".")[0]
                      }}<sup>{{ String(prices_plan[3]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <div :class="`mt-2 text-h5 font-weight-black ${class_isEyal}`"
                     v-else :key="s">
                      ${{ String(prices_plan2[3] + s.price[3]).split(".")[0]
                      }}<sup>{{ String(prices_plan2[3]).split(".")[1] }}0</sup
                      ><sub class="text-h8">{{$t(page+'.monthly')}}</sub>
                    </div>
                    <v-divider :key="s" class="my-35 mx-6"></v-divider>
                  </template>
                  <v-btn
                    :disabled="disabled_plan[3] == 1"
                    :color="selected_plan.planlevel > 3 ? 'blue' : 'primary'"
                    @click="selectPlan(5)"
                    class="my-5"
                    rounded
                    >{{
                      $t(select_plan_text[3])
                    }}</v-btn
                  >
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" lg="12" class="text-center"> </v-col>
          </v-row>
        </template>
      </div>
    </div>
    <v-dialog v-model="dialog_cancel_subscription" max-width="390">
      <v-card>
        <v-card-title class="text-h5"
          >{{$t(page+'.Subscription Cancellation')}}</v-card-title
        >
        <v-card-text>
         {{$t(page+'.Do you really want to cancel Subscription to MyProfit?')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="dialog_cancel_subscription = false">
            {{$t(page+'.Abort')}}
          </v-btn>

          <v-btn color="red darken-1" @click="cancelSubscription()">
            {{$t(page+'.Cancel Subscription')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_bottom" persistent max-width="500">
      
      <v-card
        class="pb-2 neu-glow"
        v-if="!pp_paid && !pp_cancel && !pp_error"
      >
        <div
          class="text-center px-8 py-2"
          v-if="settings.missinginvoicedata == 0"
          v-show="selected_plan"
        >
          <div
            id="paypal-button-container"
            class="pt-16 mb-12"
            ref="paypal_div"
          ></div>
        </div>
        <div class="text-center" v-else>
          <div cols="12" lg="12" class="pt-4 mb-5">
            <v-btn color="red" x-large dark to="/settings">
              {{$t(page+'.Missing Required Invoicing Data')}} <br />
              {{$t(page+'.Click Here to Fix')}}
            </v-btn>
          </div>
        </div>
        <div class="text-center">
          <v-btn class="mb-3" color="blue" dark x-small @click="noRetryBtn">
            {{$t(page+'.Close')}}
          </v-btn>
        </div>
      </v-card>
      
      <v-card class="mt-4 pb-2 pt-8 neu-glow text-center" v-if="pp_paid">
        <h1 class="display-5">{{$t(page+'.SUCCESSFULLY SUBSCRIBED!')}}</h1>
        <v-img
          contain
          height="360"
          src="/static/ob-animated-isometric/successful-purchase-animate.svg"
          lazy-src="/static/ob-animated-isometric/successful-purchase-animate.svg"
        ></v-img>
        <div class="display-2 pb-6 font-weight-bold blue-text">Thank you!</div>
        <!--
        <div class="text-center px-6 pb-4">
          In few minutes you will receive an email with the Invoice
        </div>
        -->
        <div class="text-center">
          <v-btn class="mb-3" color="primary" x-small @click="noRetryBtn">
            {{$t(page+'.Close')}}
          </v-btn>
        </div>
      </v-card>
      <v-card class="mt-4 pb-2 pt-8 neu-glow text-center" v-else-if="pp_cancel">
        <h1 class="display-5">{{$t(page+'.PAYMENT ABORTED')}}</h1>
        <v-img
          contain
          height="400"
          src="/static/ob-animated-isometric/cancel-animate.svg"
          lazy-src="/static/ob-animated-isometric/cancel-animate.svg"
        ></v-img>
        <v-btn class="mb-3 mr-16" color="orange" x-large @click="noRetryBtn">
          {{$t(page+'.Abort')}}
        </v-btn>
        <v-btn class="mb-3" color="primary" x-large @click="retryBtn">
          {{$t(page+'.Try Again')}}
        </v-btn>
      </v-card>
      <v-card class="mt-4 pb-2 pt-8 neu-glow text-center" v-else-if="pp_error">
        <h1 clas="display-5">{{$t(page+'.PAYMENT ERROR')}}</h1>
        <h2 v-if="error_message">{{error_message}}</h2>
        <v-img
          contain
          height="400"
          src="/static/ob-animated-isometric/error500-animate.svg"
          lazy-src="/static/ob-animated-isometric/error500-animate.svg"
        ></v-img>
        <v-btn class="mb-3 mr-16" color="orange" x-large @click="noRetryBtn">
         {{$t(page+'.Abort')}}
        </v-btn>
        <v-btn class="mb-3" color="primary" x-large @click="retryBtn">
          {{$t(page+'.Try Again')}}
        </v-btn>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" absolute top right :color="snackbar_color">
      <span>{{ snackbar_text }}</span>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import SkeletonRevenue from "@/components/SkeletonRevenue";

export default {
  components: { NoData, SkeletonRevenue },
  computed: {
    ...mapGetters(["settings","formattedNextBillingDate","formattedAmount","formattedNumber"]),

    formattedTimeframe: function () {
      let rsp = "",
        options = { day: "2-digit", month: "short" };
      let prcs = this.settings.timeframe;
      prcs.forEach(
        (element) =>
          (rsp +=
            new Date(element)
              .toLocaleDateString(this.settings.locale || "en", options)
              .split("T")[0] + " - ")
      );
      return rsp.slice(0, -3);
    },
  },
  data() {
    return {
      namespace: "Shop",
      page: "Shop",
      dialog_bottom: 0,
      loading: true,
      //activateselectedservices:false,
      //timeframe_dialog: false,
      dialog_cancel_subscription:false,
      errorid: null,
      services: [
        { name: "Profitability Analysis for each Store", level: 1 },
        { name: "eBay and PayPal Fees Report", level: 1 },
        { name: "Profit & Loss Report", level: 1 },
        { name: "Identify Key Trends", level: 1 },
        { name: "Refund Report", level: 4 },
        //{ name: "VA Task Management", level: 2 },
        { name: "Summary Receipt", level: 4 },
        { name: "eBay Invoice", level: 4 },
        { name: "Supplier Invoice", level: 4 },
        { name: "Price", price: [0, 0, 0, 0] },
      ],
      pp_credentials:
      {
        "sandbox":    {
                        "email":"mvcg-facilitator@tiscali.it",
                        "app_name":"jslabit",
                        "client_id":"AaLoAgLFBh7W9wFTZLhfyeiybp1dWa0_Qzz6Zm6bPmJdq9l2QsgukEhFKBzr2ShS6T7R38nAfCHMV5vW",
                        "secret_key_1":"EGILUCekFemNpIkqrysFinBP5Wxk7xV-Rtj-QWwdBypWfwwg4ILWQYN8sVhSsz4Sxrh4TJCbKyuMnV1R",
                        "webhook":{
                                    "app_name":"nvp_webhook",
                                    "client_id":"AbCu7yZZTe-p1-6waekFpa7NZjjQzVXc-_jGyDNuXzBuozgeH40em0N_T9FSDeuzP9AzmDSvCKvfZ0Et",
                                    "secret_key_1":"EHYvxVAc2F222G6H6ZvrLNFDRtRSd26VH5ylxZ_JykGYTb2Aaj2ANwKJ_c0csCAPmkd9x1qKHj61_GmC",
                                    "url":"https://ibookrestaurant.com/ajax/shop/webhook.php",
                                    "webhook_id":"35X591193G733550Y"
                                  },
                     },
        "production":{
                        "email":"mvcg@tiscali.it",
                        "app_name":"jslabit",
                        "client_id":"AcjCYu0UHz5EzxfKfkK3r8HUB43M_ie6uddGR1WT-aDwEddeOQ3pMAm4mPP-bOFsR1cGXqSWZUHRQusp",
                        "secret_key_1":"EMmNHlfIFlYNFVOnrHH2muptK7UOSHZBPiJnWYsVcNBxm0A3hgWTfBKJ56K89PwbpR1Sn9ospEwh13-q",
                        "webhook":{
                                    "app_name":"nvp_webhook",
                                    "client_id":"AVJGMc9EXN6U5CAAgRg6dmyjhdAITWsTVomOHl2FOiEHvIecwLrUt4Al2CfUxCgLOaujE1b_lca8Ua4Q",
                                    "secretkey_1":"EF9MAHQrLu7K8ilewJANn8F8zt8CueNW5ya-TIN7OgsPUqd-XXjkHIp0Zhp0Id_wgd7rN32qWJwX3Dq2",
                                    "url":"https://ibookrestaurant.com/ajax/shop/webhook.php",
                                    "webhook_id":"35X591193G733550Y"
                                  }
                    }
      },
      environment:'sandbox',
      //environment:'production',
      //sb Platform 2290192117028630441
      client_id:{"sandbox":"AaLoAgLFBh7W9wFTZLhfyeiybp1dWa0_Qzz6Zm6bPmJdq9l2QsgukEhFKBzr2ShS6T7R38nAfCHMV5vW","production":"AcjCYu0UHz5EzxfKfkK3r8HUB43M_ie6uddGR1WT-aDwEddeOQ3pMAm4mPP-bOFsR1cGXqSWZUHRQusp"},
      plans: null,
      selected_plan: {},
      selected_plan_id: null,
      //turnover:0,
      //suggestedFees:0,
      ebayaccounts: 1,
      monthlyFees: 0,
      //creditPrice:1,
      //rawCredits:0,
      search: "",
      select_plan_text: [
        "Select Plan",
        "Select Plan",
        "Select Plan",
        "Select Plan",
      ],
      disabled_plan: [1, 1, 1, 1],
      Each: 3,
      prices_basic: [0, 8.9, 13.9, 23.9],
      prices_plan2: [0, 14.9, 19.9, 29.9],
      prices_plan: [0.0, 0.0, 0.0, 0.0],
      snackbar: 0,
      snackbar_color: "",
      snackbar_text: "",
      pp_loaded: false,
      pp_paid: false,
      pp_cancel: false,
      pp_error: false,
      class_isEyal:'',
      class_notEyal:'',
      error_message:''
    };
  },
  mounted: function () {
    //const client_id='AWAU6oWNDHZosMCw_yLBRwiDd_6N6aE2nAc_fJPKFNq4X9M2_VSczCq92mAqBTjDcQx8nqlCC6XsqTSm';//sb
    //const client_id = "Ad8b15yl_SCAbExg9_80GCAFgkzQgoYF1hWemg4q6BAsZIHzQX9xUGz6y2urh9EdkS46Iz9SSv8VrZzo"; // sb Platform!
    //const client_id = "Afo3qwKl0XmNODulwkKlYArm8sn8HFpo3USZM2cBJXv6lyTeKi--gz1PLG_ID1SL12hm60QDfpJdeFUJ"; // sb Platform 2290192117028630441
    //const client_id = "AZRzPuNAh_wp8EiXuMm_tdDw4eTiMBdajotwxx853VB2GrwS-TOqi7HLohCf0W4lqdpHeelgpe-nKAX5"; // prod Platform!
    //const client_id='AWaNFcLe64_W5LkrAk4qkIYNGIgffjjTt_IkrYD7GLSpC2OcgU9U2Stj8JbKQEBhGKeb8iCkJr3V-b1P';//prod
    //const client_id='AT10NA2W3fWWn5y2UB1qX3GVnTFD8ePH9bry9D-sagmcX_4VY8SxfFA21Nri7FKpbxCQb02aGVrYnZFa';//prod jslab
    //const client_id='AUQlmG8R8vk-k-JlBQ86g1aAxQadoCyky0bQUY7AxJswZ9UgnL21iju3gcPxftUL4ClfjNDbxuS-24SW';//sb nir
    //const client_id='Aao9AE6bjszQSWQ_vmibIDVPambyC3ALRzSCTUdO7gD9LOd4dHtobTOCDBT4fwvXRp7Nyh4Jl5tDU5Su';//prod nir
    
    console.log('client_id',this.client_id[this.environment])
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://www.paypal.com/sdk/js?client-id=" +
        this.client_id[this.environment] +
        "&vault=true&intent=subscription"
    );
    //script.setAttribute('data-client-token',sessionStorage.getItem('jwt'));
    //script.addEventListener("load",this.setLoaded(2000))
    document.head.appendChild(script);
    console.log(this.settings.eBayAccountsCount);
    this.class_isEyal=this.settings.isEyal==0?'black--text':'black--text';
    this.class_notEyal=this.settings.isEyal==0?'black--text':'black--text';
    console.log('classes',this.class_isEyal,this.class_notEyal);
    switch (parseInt(this.settings.eBayAccountsCount)) {
      case 0:
      case 1:
        this.select_plan_text[0] = this.$t("Active");
        this.select_plan_text[1] = this.$t("Select Plan");
        this.select_plan_text[2] = this.$t("Select Plan");
        this.select_plan_text[3] = this.$t("Select Plan");
        this.disabled_plan[0] = 1;
        this.disabled_plan[1] = 0;           
        this.disabled_plan[2] = 0;
        this.disabled_plan[3] = 0;
        this.prices_plan = this.prices_basic;
        break;
      default:
        console.log("level", this.settings.level);
        let EAC = Math.max(this.settings.eBayAccountsCount, 2);
        this.prices_plan = this.prices_basic.map((x) => x + EAC * this.Each);
        this.prices_plan[0] = 0;
        console.log("pplan", this.prices_plan,this.settings.planlevel,this.selected_plan.planlevel);
        this.select_plan_text[0] = this.$t("Not Applicable");
        if (this.settings.planlevel)
        {
          this.selected_plan.planlevel=this.settings.planlevel;
        }
        let msg =
          this.settings.eBayAccountsCount == this.settings.subscribedeBayAccountsCount
            ? this.settings.planlevel==4 && this.settings.isEyal==0 ? this.$t("Fix") : this.$t("Active")
            :  this.settings.eBayAccountsCount > this.settings.subscribedeBayAccountsCount?this.$t("Upgrade"):this.$t("Downgrade");

        let isDisabled=this.settings.eBayAccountsCount != this.settings.subscribedeBayAccountsCount || (this.settings.planlevel==4 && this.settings.isEyal==0) ? 0 : 1;

        switch (parseInt(this.settings.planlevel)) {
          case 1:
            this.select_plan_text[1] = msg;
            this.disabled_plan[0] = 1;
            this.disabled_plan[1] = isDisabled;           
            this.disabled_plan[2] = 0;
            this.disabled_plan[3] = 0;
            break;
          case 3:
            this.select_plan_text[2] = msg;
            this.disabled_plan[0] = 1;
            this.disabled_plan[1] = 0;
            this.disabled_plan[2] = isDisabled;
            this.disabled_plan[3] = 0;
            break;
          case 4:
          case 5:
            this.select_plan_text[3] = msg;
            this.disabled_plan[0] = 1;
            this.disabled_plan[1] = 0;
            this.disabled_plan[2] = 0;
            this.disabled_plan[3] = isDisabled;
          break;
          default:
            this.disabled_plan[0] = 1;
            this.disabled_plan[1] = 0;
            this.disabled_plan[2] = 0;
            this.disabled_plan[3] = 0;
        }
    }
    console.log("spt", this.select_plan_text, this.disabled_plan);
  },
  created() {
    this.loadData();
  },
  methods: {
    selectPlan(p) {
      console.log("slctpln", p, this.settings.eBayAccountsCount,this.settings.isEyal);
      p = 3;
      console.log("plans", p, JSON.stringify(this.plans));
      /*
      this.selected_plan = this.plans.find(p => p.planlevel == p);
      this.dialot_bottom = 1;
      let ii = this.plans.findIndex((x) => x.planlevel == p);
      console.log(
        "plan",
        this.selected_plan.plan_id,
        this.selected_plan,
        ii,
        this.plans,
        this.selected_plan.planlevel
      );*/
      this.setLoaded(120);
    },
    retryBtn: function () {
      console.log("379");
      this.$refs.paypal='';
      this.dialog_bottom = 0;
      this.pp_error = false;
      this.pp_cancel = false;
      setTimeout(() => {
        this.dialog_bottom = 1;
      }, 50);
      console.log('381');
      
      this.setLoaded(100);
    },
    noRetryBtn: function () {
      console.log("379");
      this.dialog_bottom = 0;
      this.pp_error = false;
      this.pp_cancel = false;
      this.$refs.paypal='';
      //this.setLoaded(20);
    },
    setLoaded: function (ta) {
      this.pp_loaded = true;
      this.dialog_bottom = true;
      console.log("loaded", this.pp_loaded);
      setTimeout(() => {
        window.paypal
          .Buttons({
            style: {
              layout: "vertical",
              color: "blue",
              shape: "rect",
              label: "pay",
              height: 55,
            },
            createSubscription: (data, actions) => {
              if (this.settings.subscription_id) {
                console.log('shop_644',this.settings.subscription_id,this.selected_plan.plan_id);
                
                if (this.settings.subscription_status=='SUSPENDED')
                {
                  return actions.subscription.activate(this.settings.subscription_id, {
                    reason: "Reactivated by customer"
                  });
                }
                else
                {
                  
                return actions.subscription.revise(this.settings.subscription_id, {
                  plan_id: this.selected_plan.plan_id
                });
                }
              } else {
                return actions.subscription.create({
                  plan_id: this.selected_plan.plan_id,
                  start_time: this.settings.subscription_start,
                });
              }
            },
            onApprove: async (data, actions) => {
              console.log("d", data);
              if (data.subscriptionID) {
                //this.pp_paid=true;
                //this.$store.dispatch("setCredits",this.settings.credits);
                //update database
                this.saveSubscription(data);
              }
            },
            onCancel: (data) => {
              this.pp_cancel = true;
              console.log("ppcancel", data);
            },
            onError: (err) => {
              //let err_details=err.details;
              //this.error_message='Error: '+err_details.description;
              //console.log(this.error_message);
              let err_string=JSON.stringify(err);
              console.log(err_string);
              console.log(err.substr(0,30))
              console.log("erore:", err);
              this.pp_error = true;

              console.log('718',err.details.description);
            },
          })
          //.render(this.$refs.paypal_div);
          .render('#paypal-button-container')
      }, ta);
    },
    async saveSubscription(data) {
      data.plan_id = this.selected_plan.plan_id;
      data.start_time = this.settings.subscription_start;
      data.action="subscription_save";
      console.log("414", data);
      try {
        const res = await this.$http.post("/shop.php", { data });
        switch (res.data.errorid) {
          case "0":
            console.log("467", data);
            console.log("468", res.data);
            let pl=res.data.payload;
            this.pp_paid = true;
            this.settings.plan_name=pl.name;
            this.settings.planlevel=pl.planlevel
            this.settings.next_billing_time=pl.next_billing_time;
            this.settings.missinginvoicedata='0';
          break;
          case "0007":
            this.$router.push("/auth/login").catch(() => {});
            break;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async cancelSubscription() {
      this.loading = true;
      try {
        const res = await this.$http.post("/paypal/subscriptions/index.php", { "subscription_id": this.settings.subscription_id,"action":"cancelsubscription","response":"save"});
        switch (res.data.errorid) {
          case "0":
            this.plans = JSON.parse(res.data.payload.plans);
            console.log("accn", this.plans[0].accounts);

            //this.turnover=this.services[0].Turnover;
            //this.ebayaccounts=this.services[0].eBayAccounts,

            //console.log('srv',this.services)
            //console.log('dd',this.services[0].Turnover)
            break;
          case "0007":
            this.$router.push("/auth/login").catch(() => {});
            break;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const res = await this.$http.post("/shop/shop.php", {"data":{"action":"plans_read","environment": this.environment}});
        switch (res.data.errorid) {
          case "0":
            this.plans = JSON.parse(res.data.payload.plans);
            console.log("accn", this.plans[0].accounts);
            this.settings.plan_id='P-3YA105260M524904UMEAVCAI'
            this.settings.next_billing_time='2023-06-30'
            this.settings.plan_name='MyProfit Special with 14 eBay Accounts'
            this.settings.subscribedeBayAccountsCount=1
            this.settings.eBayAccountsCount=1
            this.settings.missinginvoicedata=0

            //this.turnover=this.services[0].Turnover;
            //this.ebayaccounts=this.services[0].eBayAccounts,

            //console.log('srv',this.services)
            //console.log('dd',this.services[0].Turnover)
            break;
          case "0007":
            this.$router.push("/auth/login").catch(() => {});
            break;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.my-35 {
  margin-top: 11px !important;
  margin-bottom: 11px !important;
}
.text-h7 {
  font-size: initial;
  font-weight: 400;
}
.text-h8 {
  font-size: small;
  font-weight: 400;
}
.text-h9 {
  font-size: x-small;
  font-weight: 300;
}
.ml--40 {
  margin-left: -40px;
}
</style>